import gql from 'graphql-tag';

const GET_TEMPLATE_ATTACHMENT_DOWNLOAD_URL = gql`
  query($templateId: ID!, $fileName: String) {
    getTemplateAttachmentDownloadUrl(
      templateId: $templateId
      fileName: $fileName
    )
  }
`;

//accounts-web/accounts/downloads/attachment/notificationTemplate
// GET

// "type" → NotificationTemplateType,
// "templateId"
// "fileName"

const DELETE_NOTIFICATION_TEMPLATE_ATTACHMENT = gql`
  mutation(
    $notificationTemplateType: String!
    $notificationTemplateId: ID!
    $fileName: String
  ) {
    deleteNotificationTemplateAttachment(
      notificationTemplateType: $notificationTemplateType
      notificationTemplateId: $notificationTemplateId
      fileName: $fileName
    )
  }
`;

// enum NotificationTemplateType {
//   REPLY
//   SYSTEM_ONBOARDING
//   SYSTEM_TICKETING
//   }
const DELETE_CLIENT_DOCUMENT = gql`
  mutation($deleteInput: DeleteClientAttachmentsInput!) {
    deleteClientAttachments(input: $deleteInput)
  }
`;

export {
  GET_TEMPLATE_ATTACHMENT_DOWNLOAD_URL,
  DELETE_NOTIFICATION_TEMPLATE_ATTACHMENT,
  DELETE_CLIENT_DOCUMENT
};
